export default __webpack_public_path__ + "48b020131bc303df85e57ef026344d00.svg";